import React from "react";
import {
  Container,
  Column,
  Img,
  Link,
  Row,
  Section,
  Text,
  Tailwind,
} from "@react-email/components";
import withClipboard from "@/shared/copy-to-clipboard";
import SocialLinks from "./social-links";
import { useSelector } from "react-redux";
import { selectUser } from "store/src/slices/auth-slice";

const EmailSignature2 = ({ id }) => {
  const user = useSelector(selectUser);

  return (
    <div id={id} className="bg-white w-max p-4 rounded-sm">
      <Tailwind>
        <Container
          align="none"
          className="font-mono font-semibold w-full border max-w-72 border-gray-400 border-solid"
        >
          <Section className="">
            <Row>
              <Column className="border-0  border-solid  p-3">
                <Text className="text-base leading-none m-0 text-black">
                  {user.first_name} {user.last_name}
                </Text>
                <Text className="text-xs m-0 mt-1 text-black">
                  {user.secondary_job_title || user.job_title?.name}
                </Text>
              </Column>
            </Row>
          </Section>

          <SocialLinks user={user} />

          <Section className="border-t w-full border-gray-400 border-solid ">
            <Row>
              <Column className="py-4 px-8 text-center">
                <Link
                  href={`https://7span.com/?utm_source=email&utm_medium=sign&utm_emp=${
                    user.email.split("@")[0]
                  }`}
                >
                  <Img
                    className="h-12 inline-block"
                    src="https://products.7span.in/assets/f3d89878-d0c4-4c2f-bc73-bb2ccc715f4c"
                  />
                </Link>
              </Column>
            </Row>
          </Section>
        </Container>
      </Tailwind>
    </div>
  );
};

export default withClipboard(EmailSignature2);
